import TheGrid from '@/views/dealers/dsr-new/grid'
import Edit from '@/views/dealers/dsr-new/edit'

export default {
  path: '/dealers/dsr-new',
  redirect: '/dealers/dsr-new/index',
  name: 'dsr-new',
  meta: {
    auth: {
      redirect: {
        name: 'dsr-new.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'DSR'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'dsr-new.index',
    component: TheGrid,
    meta: {
      auth: true,
      roles: ['SUPER' ,'UFS'],
      forbiddenRedirect: '/dashboard',
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'dsr-new.create',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER', 'UFS'],
      forbiddenRedirect: '/dashboard',
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'dsr-new.edit',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER','UFS'],
      forbiddenRedirect: '/dashboard',
      label: 'Editar'
    }
  }]
}
